<div class="legend">
  <div class="legend-label">{{ legendContent()?.label }}</div>
  <div class="legend-items">
    @for (level of riskLevels(); track level.name) {
      <div class="legend-item">
        <span class="color-box" [ngStyle]="{ 'background-color': level.color }"></span>
        {{ level.name }}
      </div>
    }
  </div>
</div>
